import { KUDOS_AND_BADGES_LIST, ATTENDEE_BADGES_LIST } from 'queries/kudo';
import { makeApolloClient, logError } from '../util';
import {
	UPDATE_EVENT,
	SET_KUDOS_BADGES,
	SET_ATTENDEE_BADGES,
	CREATE_KUDO_BADGE,
	UPDATE_KUDO_BADGE,
	DELETE_KUDO_BADGE,
	UPDATE_BADGE,
	ADD_GROUPS_TO_KUDO_BADGE,
	REMOVE_GROUPS_FROM_KUDO_BADGE,
	CLEAR_KUDO_BADGES,
} from './actionTypes';

export const setEventKudo = (eventKudo, from) => ({
	type: UPDATE_EVENT,
	event: eventKudo,
	from,
});

const fetchKudosBadges = (kudoOrBadges, from) => ({
	type: SET_KUDOS_BADGES,
	from,
	kudoOrBadges,
});
const fetchAttendeeBadges = (attendeeBadges, from) => ({
	type: SET_ATTENDEE_BADGES,
	attendeeBadges,
	from,
});

export const clearKudoBadges = from => ({
	type: CLEAR_KUDO_BADGES,
	from,
});

export const createKudosBadges = (kudoBadge, from) => ({
	type: CREATE_KUDO_BADGE,
	kudoBadge,
	from,
});

export const updateKudosBadges = (kudoBadge, from) => ({
	type: UPDATE_KUDO_BADGE,
	kudoBadge,
	from,
});

export const deleteKudosBadges = (kudoBadgeID, from) => ({
	type: DELETE_KUDO_BADGE,
	kudoBadgeID,
	from,
});

export const assignBadgeToAttendee = (badge, from) => ({
	type: UPDATE_BADGE,
	badge,
	from,
});

export const addGroupsToKudosBadges = (groupIDs, kudoBadgeID, from) => ({
	type: ADD_GROUPS_TO_KUDO_BADGE,
	groupIDs,
	kudoBadgeID,
	from,
});

export const removeGroupsFromKudosBadges = (groupIDs, kudoBadgeID, from) => ({
	type: REMOVE_GROUPS_FROM_KUDO_BADGE,
	groupIDs,
	kudoBadgeID,
	from,
});

export const thunkFetchKudoBadges = (eventID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { kudosAndBadgesList } = await client.request(KUDOS_AND_BADGES_LIST, {
			event_id: eventID,
		});
		dispatch(fetchKudosBadges(kudosAndBadgesList, from));
	} catch (error) {
		logError(error, 'kudos.actions.thunkFetchKudoBadges');
	}
};

export const thunkFetchAttendeeBadges = (eventID, attendeeID, from) => async (
	dispatch,
	getState
) => {
	const client = makeApolloClient(getState());
	try {
		const { attendeeKudosList } = await client.request(ATTENDEE_BADGES_LIST, {
			event_id: eventID,
			attendee_id: attendeeID,
		});
		dispatch(fetchAttendeeBadges(attendeeKudosList.badges, from));
	} catch (error) {
		logError(error, 'kudos.actions.thunkFetchAttendeeBadges');
	}
};
